export function brandHasWebsite (brand) {
  const rt = (brand.localWebURL != '' ) ? true:false
  return rt
}
export function brandHasStory (brand) {
  const rt = (brand.story_flag !== null && typeof brand.story_flag.akimamaSlug !== 'undefined' ) ? true : false
  return rt
}

export function brandIsV2 (brand) {
  const rt = (brand.brandwebsitePrimary == 1) ? true : false
  return rt
}
export function brandHasCarousel (brand) {
  const rt = (brand.brandLayoutFlag == 1 && brand.carousel && brand.carousel.length >= 1 ) ? true : false
  return rt
}

export function brandHasExtendFlag (brand) {
  const rt = (brand.brandExtendFlag == 1) ? true : false
  return rt
}
